export default __webpack_public_path__ + "static/media/dataanalysis.113bb02e.jpg";